import React from 'react'
import moment from "moment";
import {checkPermission} from "../../../../../utils/common";
import Pagination from "../../../../../components/Pagination";
import TableHeader from "../../../../../components/TableHeader";
import ModalCreateDepartment from './modalCreateDepartment'
import ModalEditDepartment from './modalEditDepartment'
import ModalDeleteDepartment from './modalDeleteDepartment'
import GroupObjectController from "../../../../../services/data-declaration/group-subject-controller";
import DepartmentController from "../../../../../services/data-declaration/department-controller";
import {getSchoolYear} from "../../../../../utils/authority";

class DepartmentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: '',
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showModalCreate: false,
            showModalEdit: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'group_name',
                    name: 'Tổ bộ môn',
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'person_name',
                    name: "Cán bộ quản lý tổ bộ môn",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'des',
                    name: "Mô tả tổ bộ môn",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
        this.searchList()
    }

    onSearch = () => {
        this.setState({showLoading: true}, () => {
            this.searchList()
        })
    };

    searchList = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        DepartmentController.getList(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };

    handleChangePage = (page) => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.searchListService()
            }
        );
    };

    renderStatus = (statusType, startDate, endDate) => {
        let currentDate = new Date();
        startDate   = moment(startDate).format("DD-MM-YYYY")
        endDate     = moment(endDate).format("DD-MM-YYYY")
        currentDate = moment(currentDate).format("DD-MM-YYYY")
        switch (statusType) {
            case "PENDING":
                return <h6><span className="badge badge-info">Đang duyệt</span></h6>;
            case "ACTIVE":
                if (startDate <= currentDate && currentDate <= endDate)
                    return <h6><span className="badge badge-success">Đang hoạt động</span></h6>;
                else if (currentDate < startDate) {
                    return <h6><span className="badge badge-info">Đang chờ</span></h6>;
                }else {
                    return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
                }
            case "DISABLE":
                return <h6><span className="badge badge-dark">Đã khóa</span></h6>;
            case "EXPIRED":
                return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
            case "DELETEs":
                return <h6><span className="badge badge-danger">Đã xóa</span></h6>;
            default:
                return '';
        }
    };

    render() {
        let {pageNumber, pageSize, accountBalance} = this.state;
        return (
            <div>
                <div className="row">
                    <div className="mb-4 col-md-12 tab-content">
                        {this.state.showLoading &&
                        <div className="content-loading col-12 ml-3 align-items-center"
                             style={{display: 'block'}}>
                            <div className="spinner-grow text-info"/>
                        </div>
                        }
                        <div className="col-12">
                            <div className='mb-4'>
                                <div className="kt-form kt-form--fit">
                                    <div className="row">
                                        <div className='col-xs-12 col-sm-12 col-md-12 text-left pl-0 mt-3'>
                                            {checkPermission("GROUP_USER_ADD") &&
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                title='Thêm mới'
                                                style={{cursor: 'pointer'}}
                                                onClick={() => {
                                                    this.setState({itemSelected: -1, showModalCreate: true})
                                                }}
                                            >
                                                Thêm mới
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-wrapper">
                                <table className="table table-striped table-data table-bordered">
                                    <thead>
                                    <TableHeader header={this.state.header} clickSort={(data) => {
                                        let a = '';
                                        if (data.sortAsc == null) {
                                            a = ''
                                        } else {
                                            a = `id_sort=${data.sortAsc ? 'asc' : 'desc'}`;
                                        }
                                        this.setState({
                                            sort: a
                                        }, () => this.searchListService())
                                    }}/>
                                    </thead>
                                    {!this.state.listData || this.state.listData.length == 0
                                        ? <tbody>
                                        <tr>
                                            <td colSpan={12}>
                                                <div className='text-center'>Không có dữ liệu</div>
                                            </td>
                                        </tr>
                                        </tbody>
                                        : <tbody>
                                        {this.state.listData.map((row, index) => (
                                            <tr key={row.id} style={{height: 50}}>
                                                <td style={{textAlign: 'center'}}>{pageNumber * pageSize + index + 1}</td>
                                                <td style={{textAlign: 'left',}}>
                                                    {row.name}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.leaderRes?.fullName}
                                                </td>
                                                <td style={{textAlign: 'left'}}>
                                                    {row.description}
                                                </td>
                                                <td className='p-1' style={{textAlign: 'center'}}>

                                                    {checkPermission("GROUP_USER_EDIT") &&
                                                    <button className="btn btn-action p-2"
                                                            title='Sửa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalEdit: true})
                                                            }}
                                                    >
                                                        <i className="ti-pencil-alt"/>
                                                    </button>
                                                    }
                                                    {checkPermission("GROUP_USER_DELETE") &&
                                                    <button className="btn btn-action p-2"
                                                            title='Xóa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                            }}
                                                    >
                                                        <i className="ti-trash"/>
                                                    </button>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>}
                                </table>
                            </div>
                            <div className="pagination-right">
                                <Pagination
                                    activePage={this.state.pageNumber}
                                    itemsCountPerPage={this.state.pageSize}
                                    totalItemsCount={this.state.totalItem}
                                    changeHandler={(page) => this.handleChangePage(page)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ModalDeleteDepartment
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />

                <ModalCreateDepartment
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />

                <ModalEditDepartment
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        )
    }

}

export default DepartmentManagement
